import { TenantSourceInfo } from '../../types';
import { Tenants, TenantsEnum } from '../../../shared/types';

type TenantSources = {
  [key in Tenants]: TenantSourceInfo;
};

export const tenantSources: TenantSources = {
  [TenantsEnum.Compensa]: {
    tenant: 'Compensa',
    sourceName: 'www.compensa.pl',
    link: 'https://www.compensa.pl/',
  },
  [TenantsEnum.Beesafe]: {
    tenant: 'Beesafe',
    sourceName: 'www.beesafe.pl',
    link: 'https://www.beesafe.pl/',
  },
  [TenantsEnum.Benefia]: {
    tenant: 'Benefia',
    sourceName: 'www.benefia.pl',
    link: 'https://www.benefia.pl/',
  },
  [TenantsEnum.Interrisk]: {
    tenant: 'Interrisk',
    sourceName: 'www.interrisk.pl',
    link: 'https://www.interrisk.pl/',
  },
  [TenantsEnum.Wiener]: {
    tenant: 'Wiener',
    sourceName: 'www.wiener.pl',
    link: 'https://www.wiener.pl/',
  },
};
